import {Component, OnInit, Inject, Input} from '@angular/core';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from 'rxjs';
import {PaymentService} from '../../services/payment.service';
import { Order } from '../../models/order';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.component.html',
  styleUrls: ['./payment-dialog.component.css']
})
export class PaymentDialogComponent implements OnInit {
  packages: any;
  page: number;
  total: number;
  max: number;
  loading: boolean;
  order: Order;
  description: string;

  price: number;
  quantity: number;
  discount: number;

  constructor(
    public dialogRef: MdDialogRef<PaymentDialogComponent>,
    public dialog: MdDialog,
    public paymentService: PaymentService
  ) {
    this.loading = true;
    this.page = 1;
    this.total = 0;
    this.max = 10;
    this.price = 79000;
    this.discount = 0;

    this.order = {
      description: '',
      packages: []
    };
  }

  ngOnInit() {
    this.searchPackages();
  }

  getTotal() {
    let total = 0;
    if (this.quantity > 0)
    {
      total = this.price * this.quantity;
    }
    return total;
  }

  getDescuento() {
    let total = 0;
    if (this.quantity >= 3 && this.quantity <= 4)
    {
      this.discount = 0.05;
    } else if (this.quantity >= 5 && this.quantity <= 9)
    {
      this.discount = 0.10;
    } else if (this.quantity >= 10 && this.quantity <= 19)
    {
      this.discount = 0.15;
    } else if (this.quantity >= 20 && this.quantity <= 99)
    {
      this.discount = 0.20;
    } else if (this.quantity >= 100)
    {
      this.discount = 0.25;
    } else {
      this.discount = 0;
    }

    if (this.quantity > 0) {
      total = this.price * this.quantity;
      total = total - (total * this.discount);
    }
    return total;
  }

  searchPackages (page?: number, query?: string, active?: boolean, deleted?: boolean) {
    this.loading = true;

    this.page = page;
    if (page == null) {
      page = 1;
    }
    this.paymentService.getPackages(page, this.max)
    .subscribe(
    data => {
      this.packages = data.packages;
      this.total = data.pagination.total;
      this.loading = false;
    },
    error => {
      if (error.status == 404) {
        this.packages = undefined;
        this.loading = false;
      } else {
        console.log(error);
        this.packages = undefined;
        this.loading = false;
      }
    });
  }

  payment() {
    this.order.description = this.description;
    this.order.packages = [];
    this.order.packages.push(
      {
        quantity: Number(this.quantity)
      }
    );
    // this.packages.forEach(element => {
    //   if (element.payQuantity > 0) {
    //     this.order.packages.push(
    //       {
    //         package_id: element.id,
    //         quantity: Number(element.payQuantity)
    //       }
    //     );
    //   }
    // });
    this.paymentService.postOrder(this.order)
    .subscribe(
    data => {
      this.dialog.open(MessageBoxDialog, {data: {title: 'Orden Realizada con Éxito', message: 'Pronto verificaremos tu pago y aprobaremos tu orden', success:true, showIcon:true}});
      this.dialogRef.close('yes');
    },
    error => {
      if (error.status == 404) {
        this.loading = false;
      } else {
        console.log(error);
        this.loading = false;
      }
      this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', message: 'No se pudo verificar tu orden:', alert:true, showIcon:true}});
      this.dialogRef.close('yes');
    });
  }

  _keyPressNumberPositive(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  onPageChange(page) {
    this.searchPackages (page);
  }

  getTotalVacanciesPayment() {
    let total = 0;
    this.packages.forEach(element => {
      if (element.payQuantity > 0) {
        total += element.payQuantity * element.quantity * element.product.job_vacancy;
      }
    });
    return total;
  }

  getTotalInvitationsPayment() {
    let total = 0;
    this.packages.forEach(element => {
      if (element.payQuantity > 0) {
        total += element.payQuantity * element.quantity * element.product.invitation;
      }
    });
    return total;
  }

  getTotalPricePayment() {
    let total = 0;
    this.packages.forEach(element => {
      if (element.payQuantity > 0) {
        total += element.payQuantity * element.price;
      }
    });
    return total;
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/payment-dialog/payment-dialog.component.ts